import { render, staticRenderFns } from "./link-route.vue?vue&type=template&id=b397f152&scoped=true&"
import script from "./link-route.vue?vue&type=script&lang=js&"
export * from "./link-route.vue?vue&type=script&lang=js&"
import style0 from "./link-route.vue?vue&type=style&index=0&id=b397f152&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b397f152",
  null
  
)

export default component.exports